import axios from '../../axios'

// 薪资待遇管理端增删查改接口

// 新增薪资待遇
export const addSalary = (data) => {
    return axios({
        url: '/api/data/wish/salary',
        method: 'POST',
        data
    })
}

// 修改薪资待遇
export const editSalary = (data) => {
    return axios({
        url: '/api/data/wish/salary',
        method: 'PUT',
        data
    })
}

// 删除薪资待遇信息
export const deleteSalary = (data) => {
    return axios({
        url: '/api/data/wish/salary',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索薪资待遇信息列表
export const searchSalaryList = (data) => {
    return axios({
        url: '/api/data/wish/salary',
        method: 'GET',
        data
    })
}

// 获取薪资待遇详情
export const getSalaryInfo = (data) => {
    return axios({
        url: '/api/data/wish/salary/info',
        method: 'GET',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/salary.js